export const autoDashboardFallback = {
    header: {
        showQuickActions: true,
    },
    dashboard: {
        lastUpdated: new Date(),
        items: [
            {
                component: 'MainTitle',
                data: {
                    title: 'Monthly Dealership Stats',
                    subtitle: 'Coming Soon',
                },
                style: {
                    gridArea: '1/1/1/9',
                },
            },
            {
                component: 'Board',
                style: {
                    gridArea: '2/1/3/9',
                },
                data: {
                    footer: {
                        title: 'Your All-Time High',
                        stats: [
                            {
                                title: 'Total Funded Amount',
                                value: '$0',
                                description: '',
                            },
                            {
                                title: 'Total Deals',
                                value: '0 Deals',
                                description: '',
                            },
                        ],
                    },
                    chart: {
                        title: 'Past Monthly Performance',
                        label: 'Funded in last 6 months',
                        totalFunded: '$0',
                        data: [],
                    },
                    statistics: {
                        fundedItems: [
                            {
                                label: 'Funded',
                                value: 0,
                            },
                            {
                                label: 'Funded',
                                value: '$0',
                            },
                        ],
                        items: [
                            {
                                label: 'Applications',
                                value: 0,
                            },
                            {
                                label: 'Approved',
                                value: '$0',
                            },
                            {
                                label: 'Approved',
                                value: 0,
                            },
                        ],
                    },
                },
            },
        ],
    },
}
